module.exports = __webpack_public_path__ + "static/courtesy_education04-566e277268169537fcdbcc3d0418bfe1.png";